import React from 'react';
import '../App.css';
import NextEventBanner from '../components/NextEventBanner';
import PageSections from '../site-content/PageSections';
import { useSitePage } from '../site/useSitePage';

function HomePage() {
  const site = useSitePage('home');
  return (
    <>
      <NextEventBanner />
      {site.status === 'loading'
        ? <div className="hero" aria-hidden="true" />
        : <PageSections slug="home" sections={site.status === 'ready' ? site.sections : undefined} />}
    </>
  );
}

export default HomePage;
